var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTelepon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2133 6.0925C4.3473 8.215 6.1743 9.9475 8.40292 11.035L10.1354 9.385C10.348 9.1825 10.663 9.115 10.9387 9.205C11.8207 9.4825 12.7735 9.6325 13.75 9.6325C14.1832 9.6325 14.5375 9.97 14.5375 10.3825V13C14.5375 13.4125 14.1832 13.75 13.75 13.75C6.35542 13.75 0.362549 8.0425 0.362549 1C0.362549 0.5875 0.716924 0.25 1.15005 0.25H3.9063C4.33942 0.25 4.6938 0.5875 4.6938 1C4.6938 1.9375 4.8513 2.8375 5.14267 3.6775C5.2293 3.94 5.1663 4.2325 4.9458 4.4425L3.2133 6.0925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelepon);
export default __webpack_public_path__ + "static/media/ic-telepon.d0fee08177f7bcd778ff9a6f770d0207.svg";
export { ForwardRef as ReactComponent };